/**
 * **Product enquiry form**
 * Requires name and email, then adds the product page details to the message.
 */
(() => {
  const forms = document.querySelectorAll('[data-ib-product-enquiry]');

  /**
   * **Valid email check**
   * A simple format check before Shopify sends the enquiry.
   */
  const isEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  /**
   * **Show a form error**
   * Writes the message as text only so nothing in the form can run as HTML.
   */
  const showError = (errorEl, message) => {
    if (!(errorEl instanceof HTMLElement)) return;
    errorEl.hidden = false;
    errorEl.textContent = message;
    errorEl.focus();
  };

  /**
   * **Hide a form error**
   */
  const hideError = (errorEl) => {
    if (!(errorEl instanceof HTMLElement)) return;
    errorEl.hidden = true;
    errorEl.textContent = '';
  };

  /**
   * **Build the product context**
   * Puts the product and page URL at the top of the comment the store receives.
   */
  const withProductContext = (form, comment) => {
    const title = form.dataset.productTitle || '';
    const sku = form.dataset.productSku || '';
    const page = form.dataset.productPage || window.location.href;
    const lines = [
      'Product enquiry',
      title ? `Product: ${title}` : '',
      sku ? `SKU: ${sku}` : '',
      page ? `Page: ${page}` : '',
      '',
      comment,
    ];
    return lines.filter((line, index) => line !== '' || index > 3).join('\n');
  };

  forms.forEach((form) => {
    if (!(form instanceof HTMLFormElement)) return;

    const errorEl = form.querySelector('[data-ib-enquiry-error]');
    const nameInput = form.querySelector('[name="contact[name]"]');
    const emailInput = form.querySelector('[name="contact[email]"]');
    const bodyInput = form.querySelector('[name="contact[body]"]');

    form.addEventListener('submit', (event) => {
      const name = nameInput instanceof HTMLInputElement ? nameInput.value.trim() : '';
      const email = emailInput instanceof HTMLInputElement ? emailInput.value.trim() : '';
      const comment = bodyInput instanceof HTMLTextAreaElement ? bodyInput.value.trim() : '';

      if (!name) {
        event.preventDefault();
        showError(errorEl, form.dataset.errorName || 'Please enter your name.');
        if (nameInput instanceof HTMLInputElement) nameInput.focus();
        return;
      }

      if (!email || !isEmail(email)) {
        event.preventDefault();
        showError(errorEl, form.dataset.errorEmail || 'Please enter a valid email address.');
        if (emailInput instanceof HTMLInputElement) emailInput.focus();
        return;
      }

      hideError(errorEl);

      if (nameInput instanceof HTMLInputElement) nameInput.value = name;
      if (emailInput instanceof HTMLInputElement) emailInput.value = email;
      if (bodyInput instanceof HTMLTextAreaElement) {
        bodyInput.value = withProductContext(form, comment);
      }
    });
  });
})();
